export { DefaultVariation as default } from './DefaultVariation';
